import { DOCUMENT } from '@angular/common';
import {
	ApplicationRef,
	ComponentRef,
	createComponent,
	inject,
	Injectable,
	INJECTOR,
	signal,
} from '@angular/core';

import { SourcePreviewModalComponent } from '../components/modal/source-preview-modal.component';
import { SourcePreviewByNode } from '../types/source-preview-input';

@Injectable()
export class SourcePreviewService {
	private readonly document = inject(DOCUMENT);
	private readonly appRef = inject(ApplicationRef);
	private readonly injector = inject(INJECTOR);

	public readonly $sources = signal<SourcePreviewByNode[]>([]);

	public readonly $selected = signal<{ nodeId: string; sourceId: string | null } | null>(null);

	private onOpen = () => {};
	private onClose = () => {};

	private componentRef?: ComponentRef<SourcePreviewModalComponent>;

	/**
	 * This is a hack to set the Onboarding restrictions
	 */
	public callbackOnOpen(cb: () => void): void {
		this.onOpen = cb;
	}

	/**
	 * This is a hack to set the Onboarding restrictions
	 */
	public callbackOnClose(cb: () => void): void {
		this.onClose = cb;
	}

	public openPreview(
		sources: SourcePreviewByNode[],
		selectedId: { nodeId: string | null; sourceId: string | null },
		showDownloadButton = true
	): void {
		this.close();

		this.$sources.set(sources);
		this.$selected.set(this.resolveSelected(sources, selectedId));

		const ref = createComponent(SourcePreviewModalComponent, {
			environmentInjector: this.appRef.injector,
			elementInjector: this.injector,
		});
		this.componentRef = ref;

		this.componentRef.setInput('showDownloadButton', showDownloadButton);

		this.onOpen();

		this.appRef.attachView(ref.hostView);

		this.document.body.appendChild(ref.location.nativeElement);
	}

	public close(): void {
		this.onClose();

		if (this.componentRef) {
			this.appRef.detachView(this.componentRef.hostView);
			this.componentRef.destroy();
			this.componentRef = undefined;
		}

		this.$selected.set(null);
	}

	private resolveSelected(
		sources: SourcePreviewByNode[],
		selectedId: { nodeId: string | null; sourceId: string | null }
	): { nodeId: string; sourceId: string | null } | null {
		if (selectedId.sourceId) {
			const selectedNode = sources.find((item) => {
				return item.sources.some((source) => source.id === selectedId.sourceId);
			});

			if (selectedNode) {
				return {
					nodeId: selectedNode.node.id,
					sourceId: selectedId.sourceId,
				};
			}
		}

		if (selectedId.nodeId) {
			const selectedNode = sources.find((item) => item.node.id === selectedId.nodeId);

			if (selectedNode) {
				return {
					nodeId: selectedNode.node.id,
					sourceId: selectedId.sourceId,
				};
			}
		}

		return null;
	}
}
